import { render, staticRenderFns } from "./inspectionMsg.vue?vue&type=template&id=0f79e5c1&scoped=true&"
import script from "./inspectionMsg.vue?vue&type=script&lang=js&"
export * from "./inspectionMsg.vue?vue&type=script&lang=js&"
import style0 from "./inspectionMsg.vue?vue&type=style&index=0&id=0f79e5c1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f79e5c1",
  null
  
)

export default component.exports